import React, { useContext, useEffect, useState } from 'react';
import previous from './assets/previous.svg';
import next from './assets/next.svg';
import resume from './assets/pause.svg';
import { IoIosPause } from "react-icons/io";
import './BottomSidebar.css';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import ValidationModals from './PopupModals/ValidationModals';
import { Presentation, PresentationVersion } from '../types/presentation';
import { useVideoContext } from './Context/VideoContext';
import UserContext from "../contexts/user";
import { format } from 'path';
import updatePresentationVersion from './Api/updatePresentationVersion';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { DetailsType, NewThumbnail } from './ChapterSection';
import { ImageActionState, PreSignedUrl } from './ChapterEditorMain';
import { getS3PathFromSignedUrl, createS3Url, getBucketFromSignedUrl } from './utils/s3Utils';
import { deleteFromS3, uploadToS3 } from './Api/UploadToS3';
import SaveProgressModals from './PopupModals/SaveProgressModals';
import backbtn from "../VideoEditor/assets/backButton.svg";
import { de } from 'date-fns/locale';
import Chapters from './Chapters';

// Add ChapterData interface
interface ChapterData {
  id: number;
  url: string;
  time: number;
  duration: number;
  width: number;
}

export type SpeakerInfo = {
  presentation_name: string;
  title: string;
  firstName: string;
  lastName: string;
  speaker_id: string;
  picture: string;
  start_time: string | number;
  end_time: string | number;
  date: string;
  day: string | number
  presentation_id: string;
  event_slug: string;
};

type Props = {
  speaker_info: SpeakerInfo;
  locale: string
  setLocale: string
  hasModification: boolean;
  setHasModification: (value: boolean) => void;
  version_id: string;
  // chapters: ChapterData[];
  // setChapters: (chapters: ChapterData[]) => void;
  setDetails: React.Dispatch<React.SetStateAction<DetailsType>>;
  details: DetailsType
  signedUrl: PreSignedUrl[];
  removedThumbnails: string[];
  setRemovedThumbnails: React.Dispatch<React.SetStateAction<string[]>>;
  newThumbnails: NewThumbnail[];
  setNewThumbnails: React.Dispatch<React.SetStateAction<NewThumbnail[]>>;
  selectedChapters: ImageActionState;
  setSelectedChapters: React.Dispatch<React.SetStateAction<ImageActionState>>;
  setUpdateStatus: React.Dispatch<React.SetStateAction<Boolean>>;
  PresentationData: Presentation[] | undefined;
};

const BottomSidebar: React.FC<Props> =
  ({
    speaker_info,
    locale,
    setLocale,
    hasModification,
    setHasModification,
    version_id,
    // chapters,
    // setChapters,
    details,
    setDetails,
    signedUrl,
    removedThumbnails,
    setRemovedThumbnails,
    newThumbnails,
    setNewThumbnails,
    selectedChapters,
    setSelectedChapters,
    setUpdateStatus,
    PresentationData
  }) => {
    const [signedUrls, setSignedUrls] = useState(null);
    const [sidebarData, setSidebarData] = useState<PresentationVersion>();
    const { isPlaying, togglePlay, seek, duration } = useVideoContext(); // Use seek from VideoContext
    const userContext = useContext(UserContext);
    const [isMobile, setIsMobile] = useState(false);
    const [currentTime, setCurrentTime] = useState<number>(0);
    const [clickedButton, setClickedButton] = useState<string | null>(null);
    const history = useHistory();
    const { presentation_name, title, firstName, lastName, speaker_id, picture, start_time, end_time, date, presentation_id, event_slug } = speaker_info;
    console.log(useVideoContext(), "useVideoContext");

    
    // Check if the screen size is mobile
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 992); // Bootstrap's lg breakpoint
      };

      // Initial check
      handleResize();

      // Add event listener for window resize
      window.addEventListener('resize', handleResize);

      // Cleanup
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
      const handleTimeUpdate = (event: MessageEvent) => {
        try {
          const eventData = JSON.parse(event.data);

          // Parse event data
          if (eventData.type === "progress" && eventData.data?.time !== undefined) {
            setCurrentTime(eventData.data.time);
          }
        } catch (error) {
          console.error("Error parsing event data:", error);
        }
      };

      window.addEventListener('message', handleTimeUpdate);

      return () => {
        window.removeEventListener('message', handleTimeUpdate);
      };
    }, []);

    const formatVideoTime = (seconds: number): string => {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    };




    let token: any = localStorage.getItem(`token-${event_slug}`);

    useEffect(() => {
      const fetchPresentation = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/presentation/${presentation_id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            }
          });
          setSidebarData(response.data.data);
        } catch (error) {
        }
      };
      fetchPresentation();
    }, [presentation_id]);

    // Date formatting function
    function formatDate(date: string, locale: string) {
      if (!date || date === "0000-00-00") {
        return {
          formattedDate: locale === 'fr' ? "Date non disponible" : "Date not available",
          day: '',
          month: '',
        };
      }

      const [year, monthNum, day] = date.split("-");

      const getMonthName = (monthNumber: string, locale: string): string => {
        const monthIndex = parseInt(monthNumber, 10) - 1;
        const englishMonths = [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        const frenchMonths = [
          'Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin',
          'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'
        ];
        return locale === 'fr' ? frenchMonths[monthIndex] : englishMonths[monthIndex];
      };

      const monthName = getMonthName(monthNum, locale);

      return {
        formattedDate: `${day}/${monthName}`,
        day,
        month: monthName,
      };
    }

    // Time formatting function
    function formatTime(time: string, locale: string): string {
      if (!time) return locale === 'fr' ? "Heure invalide" : "Invalid Time";

      const [hours, minutes] = time.split(":");
      if (isNaN(Number(hours)) || isNaN(Number(minutes))) {
        return locale === 'fr' ? "Heure invalide" : "Invalid Time";
      }

      if (locale === 'en') {
        const hour = parseInt(hours, 10);
        const period = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12;
        return `${hour12}:${minutes} ${period}`;
      } else {
        return `${hours}h${minutes}`;
      }
    }

    // Format the date
    const { formattedDate, day, month } = formatDate(sidebarData?.date ?? "0000-00-00", locale);

    // Format the times
    const formattedStartTime = formatTime(sidebarData?.time ?? "", locale);
    const formattedEndTime = formatTime(sidebarData?.end_time ?? "", locale);

    useEffect(() => {
      const fetchThumbnailUrls = async () => {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API_ENDPOINT}/api/s3/images`,
            { key: userContext.user?.photo ?? picture },
            { headers: { 'Content-Type': 'application/json' } }
          );
          if (response.data.data) {
            setSignedUrls(response.data.data.signedUrl);
          }
        } catch (error) {
          console.error(`Failed to fetch signed URL for key: ${picture}`, error);
        }
      };
      if (picture) {
        fetchThumbnailUrls();
      }
    }, [picture, setSignedUrls]);

    // Seek backward by 2 seconds
    const seekBackward = () => {
      const newTime = currentTime - 2;
      seek(newTime);
    };

    // Seek forward by 2 seconds
    const seekForward = () => {
      const newTime = currentTime + 2;
      seek(newTime);
    };

    const handleButtonClick = (buttonType: string) => {
      setClickedButton(buttonType);
      setTimeout(() => {
        setClickedButton(null);
      }, 200); // Reset after 200ms
    };

    const handleConvertUrl = (presignedUrl: string) => {
      const s3Path = getS3PathFromSignedUrl(presignedUrl);
      return s3Path;
    };

    // console.log(selectedChapters, "selelslslllsls");

    const HandleProgressSave = async () => {
      try {
        const listUserString = localStorage.getItem(`list-user-${event_slug}`);

        const token = listUserString ? JSON.parse(listUserString).token : null;
        const presentationId = presentation_id;
        const eventId = localStorage.getItem(`event-event-id`);

        if (!version_id) {
          console.error("Version ID not found");
          return;
        }

        // // Delete removed thumbnails from S3
        // if (removedThumbnails.length > 0) {
        //   const deleteResult = await deleteFromS3(removedThumbnails, event_slug);
        //   if (!deleteResult.success) {
        //     console.error("Failed to delete thumbnails:", deleteResult.error);
        //     toast.error("Failed to delete some thumbnails");
        //   }
        // }

        // // Upload new thumbnails to S3
        // if (newThumbnails.length > 0) {
        //   const uploadResult = await uploadToS3(newThumbnails);
        //   if (!uploadResult.success) {
        //     console.error("Failed to upload thumbnails:", uploadResult.error);
        //     toast.error("Failed to upload some thumbnails");
        //   } else {
        //     // Update chapters with the new thumbnail URLs
        //     const updatedChapters = chapters.map(chapter => {
        //       const uploadedThumbnail = uploadResult.uploadedThumbnails.find(
        //         thumb => thumb.id === chapter.id
        //       );
        //       if (uploadedThumbnail) {
        //         return {
        //           ...chapter,
        //           url: uploadedThumbnail.signedUrl
        //         };
        //       }
        //       return chapter;
        //     });
        //     setChapters(updatedChapters);
        //   }
        // }

        const payload = {
          thumbnails: selectedChapters.chapters.map((thumbnail, index) => {
            const s3Path = handleConvertUrl(thumbnail.url);
            console.log(details[thumbnail.id].topic, index, "details[index].topic");
            console.log(details[thumbnail.id].title, "details[index].title");
            console.log(details, "details");


            return {
              id: s3Path,
              time: thumbnail.time.toString(),
              title: details[thumbnail.id].title,
              description: details[thumbnail.id].topic,
              width: thumbnail.width
            };
          }),
          date: new Date().toString(),
        };

        try {
          const result = await updatePresentationVersion(presentationId, token, payload, version_id, eventId);
          if (result) {
            toast.success("Progress saved successfully");
            setHasModification(false);
            setUpdateStatus(true)
          }
        } catch (error) {
          console.error("Failed to update presentation:", error);
          toast.error("Failed to save progress");
        }

      } catch (error) {
        console.error(error, "error in saving progress");
        toast.error("An error occurred while saving progress");
      }
    };

    console.log(duration, "duration");
    // console.log(chapters, "chapterssss");


    return (
      <div
        className="text-white d-flex flex-column flex-lg-row align-items-center position-relative"
        style={{
          backgroundColor: '#32363F',
          bottom: 0,
          left: 0,
          right: 0,
        }}>
        {/* Event Logo */}
        <div
          className="d-flex flex-shrink-0 bg-white d-none d-lg-flex justify-content-center align-items-center"
          style={{
            width: '100px',
            height: '80px',
            overflow: 'hidden'
          }}
        >
          <img
            src='/images/logo-default.png'
            alt="Event Logo"
            className="img-fluid "
          />
        </div>

        {/* Back Button */}
        <div
          className="d-flex align-items-center justify-content-center justify-content-sm-start round-back-btn"
        >
          {hasModification === false ? (
            <img
              src={backbtn}
              onClick={() => history.push(`/${event_slug}/my-presentations/${presentation_id}/videos`)}
              alt="Back Button"
              className="p-2 btn justify-content-center"
              style={{ cursor: "pointer" }}
            />
          ) : (
            <ValidationModals speakerInfo={speaker_info} locale={locale} />
          )}
        </div>

        {/* Presentation and Speaker Info */}
        <div className="d-flex flex-grow-1 align-items-center gap-0 flex-wrap ml-3 flex-column flex-sm-row">
          <img
            src={signedUrls || ""}
            alt="Speaker" width={50} height={50} className="rounded-md" />
          <div className="p-3 text-center text-sm-left">
            <h2 className="h5 font-weight-bold mb-0">{sidebarData?.name || "Title of the persentation"}</h2>
            <p className="small mt-2 mb-0" style={{ color: "D7D8D9" }}>{title}{userContext.user?.name ?? picture}</p>
          </div>
          <div className="text-left flex-grow-1 ml-5 mt-4 d-none d-lg-block">
            <p className="small mt-4 font-weight-bold" style={{ color: '#D7D8D9' }}>{day}/{month} <span className='ml-2'>{formattedStartTime} - {formattedEndTime}</span> </p>
          </div>
        </div>

        {/* Timer and Controls */}
        <div className="d-flex flex-row flex-sm-row align-items-center justify-content-center ml-4 mt-2 mt-lg-0">
          <span
            className="small px-3 py-2 rounded-pill mb-2 mb-lg-0"
            style={{ backgroundColor: '#4B4F5A' }}
          >
            {formatVideoTime(currentTime)} / {formatVideoTime(duration)}
          </span>
          <div className={`d-flex ml-4 justify-content-center ${hasModification ? "pr-0" : "pr-3"}`}>
            <button
              className={`play-back p-0 rounded ${clickedButton === 'previous' ? 'clicked' : ''}`}
              onClick={() => {
                handleButtonClick('previous');
                seekBackward();
              }}
            >
              <img src={previous} alt="Previous" className="w-100 h-100" />
            </button>

            <button
              className={`play-back p-0 ${clickedButton === 'play' ? 'clicked' : ''}`}
              onClick={() => {
                handleButtonClick('play');
                togglePlay();
              }}
            >
              {isPlaying ? (
                <IoIosPause
                  className="text-white p-2"
                  size={10}
                  style={{
                    width: '40px',
                    height: '40px',
                  }}
                />
              ) : (
                <img src={resume} alt="Play" className="w-100 h-100" />
              )}
            </button>

            <button
              className={`play-back p-0 rounded ${clickedButton === 'next' ? 'clicked' : ''}`}
              onClick={() => {
                handleButtonClick('next');
                seekForward();
              }}
            >
              <img src={next} alt="Next" className="w-100 h-100" />
            </button>
          </div>
        </div>

        {/* Cancel and Save Buttons */}
        {hasModification && ( // Only render if there are modifications
          <div className="p-2 d-flex gap-2 ml-4 mt-2 mt-lg-0">
            <button
              className="save-button"
              onClick={HandleProgressSave}
            >
              SAVE
            </button>
            {/* <SaveProgressModals speakerInfo={speaker_info} locale={locale} onClick={HandleProgressSave} /> */}
          </div>
        )}

        {/* Mobile-only section for date/time info */}
        <div className="d-block d-lg-none w-100 text-center mt-3">
          <p className="small mb-0 font-weight-bold" style={{ color: '#D7D8D9' }}>{day}/{month} <span className='ml-2'>{formattedStartTime} - {formattedEndTime}</span></p>
        </div>
        <ToastContainer />
      </div>
    );
  };

export default BottomSidebar;